import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import withMobile from '../hocs/withMobile';

const Headline = ({ children, ...rest }) => (
  <StyledHeadline {...rest}>{children}</StyledHeadline>
);

const StyledHeadline = styled.div`
  ${(props) =>
    props.theme.typography[props.isMobile ? 'headline3' : 'headline2']};
  margin-top: 15px;
  margin-bottom: 10px;
`;

Headline.propTypes = {
  children: PropTypes.node.isRequired,
  isMobile: PropTypes.bool,
};

Headline.defaultProps = {
  isMobile: false,
};

export default withMobile(Headline);
